goog.provide("shadow.js.shim.module$src$svg$objects$target_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$target_svg");
shadow.js.shim.module$src$svg$objects$target_svg = shadow.js.nativeProvides["src/svg/objects/target.svg"] = shadow$bridge("src/svg/objects/target.svg");
module$shadow_js_shim_module$src$svg$objects$target_svg.default = shadow.js.shim.module$src$svg$objects$target_svg;
